import React from 'react'
import type { ICellRendererParams } from 'ag-grid-enterprise'
import { ColorSwatch, DropdownCellLayout } from './CellComponents'

export const ColorCellRenderer: React.FC<ICellRendererParams> = ({ value }) => (
  <DropdownCellLayout>{value && <ColorSwatch color={value} />}</DropdownCellLayout>
)
